import { getDeactivatedRoutes } from '../utils/get-deactivated-routes';
/**
 * Обработка деактивации роутов
 */
export var deactivationHandler = function (router) { return function (toState, fromState, done) {
    var routes = router.getDependencies().routes;
    var deactivatedRoutes = getDeactivatedRoutes(toState, fromState, routes);
    if (deactivatedRoutes && deactivatedRoutes.length > 0) {
        deactivatedRoutes.forEach(function (route) {
            var _a;
            if ((_a = route === null || route === void 0 ? void 0 : route.actionResult) === null || _a === void 0 ? void 0 : _a.onDeactivate) {
                route.actionResult.onDeactivate();
            }
        });
    }
    done();
}; };
